<mat-dialog-content style="max-height: 90vw">
  <div id="w3l-appointment">
  <section class="w3l-form-25">
    <div class="form-inner-cont">
      <div class="w3l-form-25">
          <h1 style ="font-size: 200%;font-weight: bold;">{{'Diagnosis' | translate }}</h1>
      </div>
    </div>
  </section>
  <div class="top-header">
    <div class="d-grid grid-columns-top-3">

        <div class="accounts" style="left: 50px;">
          <div class="appointment-form-field">
            <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
            <label style="font-size: large;font-weight: bold;left: 150px;">Patient :</label>
            <label style="font-size: large;font-weight: bold;left: 50px;">{{patientcode}}</label>
            <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
            <label style="font-size: large;font-weight: bold;left: 190px;">{{patientname}}</label>
          </div>
          <ul>
            <label style="font-size: large;font-weight: bold;left: 150px;">     </label>
       
            <label style="font-size: large;font-weight: bold;">Date     :{{digdate}}</label>
            <label style="font-size: large;font-weight: bold;">     </label>
            <label style="font-size: large;font-weight: bold;">{{digtime}}</label>
          </ul>
        </div>
    </div>
</div>
<mat-divider></mat-divider>
<BR>
  <div>
  <div class="styled-input">
      <label style = "width: 25%;">Date</label>
      <label style = "width: 25%;">Location</label>
      <label style = "width: 24%;">Cancer Type</label>
      <label style = "width: 15%;">Sub. Type</label>
      <!-- <label style = "width: 15%;">Date of the first diagnosis</label> -->
  <div class="appointment-form-field">
  <input type="date" name="site" [(ngModel)]="digdate" style="width: 20%;" required="" />
  <label style = "width: 5%;"></label>
  <select id="location" name="location"   [(ngModel)]="declocation" style="width: 20%;background-color:  rgb(187, 203, 238);"  required>
      <option value="{{doc.compCode}}"  *ngFor="let doc of companyList; let i = index">{{doc.compName}}</option>
  </select>
  <label style = "width: 5%;"></label>
  <span class="fa fa-bars" style="cursor: grab; width:50px;"   aria-hidden="true"  ></span>
  <select id="Cancername0" name="Canername" required="" [(ngModel)]= "cancerid"  style="width: 20%;background-color:  rgb(187, 203, 238);" (change)="retriveCancerDetLookup()">
    <option value="{{Patholo.cancerID}}" *ngFor="let Patholo of cancerList; let i = index">{{Patholo.cancerName}}</option>
  </select>
  <select   id="Sub Cancer Type" name="Sub Cancer Type" [(ngModel)]="subcancerid" [value]="subcancerid" style="width: 20%;background-color:  rgb(187, 203, 238);"  (change)="Change_Cancer_Type()" required>
    <option value="">Select* </option>
    <option value="{{candet.notes}}" *ngFor="let candet of cancerDetList; let i = index">{{candet.cancerName}}</option>
  </select>

</div>
</div>
<div>
  <mat-divider></mat-divider>
  <br>
  <section *ngIf="!heddin_Non12Cancer">

  </section>
<!-- **************************** Start For the 12 Cancer Types Line **************************** -->
<section *ngIf="!heddin_Non12Cancer">
  <div class="styled-input" >
              <label  *ngIf="!heddin_tissuehed" class="Header-Lab" style = "color: #fff;width: {{tissuesiz0}}%;">{{tissuehed}}</label>
              <label  *ngIf="!heddin_tissuehed"  style = "color: #fff;width: 0.5%;"></label>

              <label  *ngIf="!heddin_histologyhed" class="Header-Lab" style = "color: #fff;width: {{histologysize0}}%;">{{histologyhed}}</label>
              <label  *ngIf="!heddin_histologyhed"  style = "color: #fff;width: 0.5%;"></label>

              <label  *ngIf="!heddin_er" class="Header-Lab" style = "color: #fff;width: {{ersiz0}}%;">{{erhed}}</label>
              <label  *ngIf="!heddin_er"  style = "color: #fff;width: 0.5%;"></label>

              <label  *ngIf="!heddin_prhed" class="Header-Lab" style = "color: #fff;width: {{prsiz0}}%;">{{prhed}}</label>
              <label  *ngIf="!heddin_prhed"  style = "color: #fff;width: 0.8%;"></label>
             
             
              <label  *ngIf="!heddin_her2hed"   class="Header-Lab" style = "color: #fff;width: {{her2ihshedsize0}}%;">{{her2hed}}</label>
              <label  *ngIf="!heddin_her2hed"   style = "color: #fff;width: 0.5%;"></label>

              <label  *ngIf="!heddin_her2ihs" class="Header-Lab" style = "color: #fff;width: {{her2hedsize0}}%;">{{her2ihshed}}</label>
              <label  *ngIf="!heddin_her2ihs" style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_her2fish" class="Header-Lab" style = "color: #fff;width: {{her2hedsize0}}%;">{{her2fishhed}} </label>
              <label  *ngIf="!heddin_her2fish"  style = "color: #fff;width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_ki67" class="Header-Lab" style = "color: #fff;width: {{ki67size0}}{{ki67Perc}};">{{ki67hed}} </label>
              <label  *ngIf="!heddin_ki67" style = "width: 0.5%;"> </label>

              <label  *ngIf="!heddin_pdl1" class="Header-Lab" style = "color: #fff; width: {{pdl1size0}}%;">{{pdl1hed}}</label>
              <label  *ngIf="!heddin_pdl1" style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_brca1" class="Header-Lab" style = "color: #fff;width: {{brcasize0}}%;">{{brca1hed}}</label>
              <label  *ngIf="!heddin_brca1" style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_brca2" class="Header-Lab" style = "color: #fff;width: {{brcasize0}}%;">{{brca2hed}}</label>
              <label  *ngIf="!heddin_brca2" style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_msihed"  class="Header-Lab" style = "color: #fff;width: {{msisize0}}%;">{{msihed}}</label>
              <label  *ngIf="!heddin_msihed"  style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_egfr" class="Header-Lab" style = "color: #fff;width: {{egfrsize0}}%;text-align: center;">{{egfrhed}}</label>
              <label  *ngIf="!heddin_egfr" style = "width: 0.5%;text-align: center;"></label>
              
              <label  *ngIf="!heddin_alk" class="Header-Lab" style = "color: #fff;width: {{alksiz0}}%;text-align: center;">{{alkhed}}</label>
              <label  *ngIf="!heddin_alk" style = "width: 0.5%;text-align: center;"></label>

              <label  *ngIf="!heddin_krashed"  class="Header-Lab" style = "color: #fff;width: {{krassize0}}%;">{{krashed}}</label>
              <label  *ngIf="!heddin_krashed"  style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_brafhed" class="Header-Lab" style = "color: #fff;width: {{brafsize0}}%;">{{brafhed}}</label>
              <label  *ngIf="!heddin_brafhed" style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_hrdhed" class="Header-Lab" style = "color: #fff;width: {{hrdsize0}}%;">{{hrdhed}}</label>
              <label  *ngIf="!heddin_hrdhed" style = "width: 0.5%;"></label>
              
              <label  *ngIf="!heddin_gscore" class="Header-Lab" style = "color: #fff;width: {{gscoresize0}}%;text-align: center;">{{gscorehed}}</label>
              <label  *ngIf="!heddin_gscore" style = "width: 0.5%;text-align: center;"></label>
              
              <label  *ngIf="!heddin_nfeature" class="Header-Lab" style = "color: #fff;width: {{Neuroendocrinesize0}}%;text-align: center;">{{Neuroendocrine}}</label>
              <label  *ngIf="!heddin_nfeature" style = "width: 0.5%;text-align: center;"></label>

              <label  *ngIf="!heddin_hpv" class="Header-Lab" style = "color: #fff;width: {{hpvsize0}}%;text-align: center;">{{hpvhed}}</label>
              <label  *ngIf="!heddin_hpv" style = "width: 0.5%;text-align: center;"></label>

  <div class="appointment-form-field">
    <select  *ngIf="!heddin_tissue" id="Site of specimen" name="Site of specimen" [(ngModel)]="tissue" style="width: {{tissuesiz}}%;background-color:  rgb(187, 203, 238);" required>
        <option value="">Select* </option>
        <option value={{tissuevalue1}}>{{tissuevalue1}}</option>
        <option value={{tissuevalue2}}>{{tissuevalue2}}</option>
        <option value={{tissuevalue3}}>{{tissuevalue3}}</option>
        <option value={{tissuevalue4}}>{{tissuevalue4}}</option>
        <option value={{tissuevalue5}}>{{tissuevalue5}}</option>
        <option value={{tissuevalue6}}>{{tissuevalue6}}</option>
    </select>
    <input *ngIf="!heddin_tissuetext" type="number" style="width: {{tissuesiz}}%;background-color:  rgb(187, 203, 238);" [(ngModel)]="tissue">
    <label  *ngIf="!heddin_tissuetext" style = "width: 1%;"></label>
    <label  *ngIf="!heddin_tissue" style = "width: 1%;"></label>

    <select *ngIf="!heddin_histology" id="histology" name="histology" [(ngModel)]="histology" style="width: {{histologysize}}%;background-color:  rgb(187, 203, 238);" required>
                <option value="">Select* </option>
                <option value={{hisologyvalue1}}>{{hisologyvalue1}}</option>
                <option value={{hisologyvalue2}}>{{hisologyvalue2}}</option>
                <option value={{hisologyvalue3}}>{{hisologyvalue3}}</option>
                <option value={{hisologyvalue4}}>{{hisologyvalue4}}</option>
                <option value={{hisologyvalue5}}>{{hisologyvalue5}}</option>
                <option value={{hisologyvalue6}}>{{hisologyvalue6}}</option>
                <option value={{hisologyvalue7}}>{{hisologyvalue7}}</option>

    </select>
    <label  *ngIf="!heddin_histology"  style = "width: 1%;"></label>

    <select *ngIf="!heddin_er"  id="er" name="er" [(ngModel)]="er" style="width: {{ersiz}}%;background-color:  rgb(187, 203, 238);"   required>
              <option value="">Slect* </option>
              <option value={{ervalue1}}>{{ervalue1}} </option>
              <option value={{ervalue2}}>{{ervalue2}}</option>
    </select>
    <label *ngIf="!heddin_er"  style = "width: 1%;"></label>

    <select  *ngIf="!heddin_pr" id="pr" name="pr" [(ngModel)]="pr" style="width: {{prsize}}%;background-color:  rgb(187, 203, 238);"    required>
              <option value="">Select* </option>
              <option value={{prvalue1}}>{{prvalue1}} </option>
              <option value={{prvalue2}}>{{prvalue2}}</option>
              <option value={{prvalue3}}>{{prvalue3}}</option>
              <option value={{prvalue4}}>{{prvalue4}}</option>
    </select>
   <label  *ngIf="!heddin_pr" style = "width: 1%"></label>

   <select *ngIf="!heddin_her2" id="her2" name="her2" [(ngModel)]="her2" style="width: {{her2hedsize}}%;background-color:  rgb(187, 203, 238);"   required>
    <option value="">Select* </option>
    <option value={{her2value1}}>{{her2value1}}</option>
    <option value={{her2value2}}>{{her2value2}}</option>
   </select>
   <label *ngIf="!heddin_her2"  style = "width: 1%;"></label>

   <select  *ngIf="!heddin_her2ihs" id="her2ihs" name="her2ihs" [(ngModel)]="her2ihs" style="width: {{her2ihshedsize}}%;background-color:  rgb(187, 203, 238);"   required>
    <option value="">Select* </option>
    <option value={{her2ihsvalue1}}>{{her2ihsvalue1}}</option>
    <option value={{her2ihsvalue2}}>{{her2ihsvalue2}}</option>
    <option value={{her2ihsvalue3}}>{{her2ihsvalue3}}</option>
    <option value={{her2ihsvalue4}}>{{her2ihsvalue4}}</option>
  </select>
  <label *ngIf="!heddin_her2ihs" style = "width: 1%"></label>

  <select *ngIf="!heddin_her2fish" id="her2fish" name="her2fish" [(ngModel)]="her2fish" style="width: {{her2ihshedsize}}%;background-color:  rgb(187, 203, 238);"   required>
    <option value="">Select* </option>
    <option value="Positive">Positive </option>
    <option value="Negative">Negative</option>
  </select>
  <label *ngIf="!heddin_her2fish" style = "width: 1%"></label>

  <input *ngIf="!heddin_ki67" type="number" style="width: {{ki67size}}%;background-color:  rgb(187, 203, 238);" [(ngModel)]="ki67">
  <label *ngIf="!heddin_ki67" style = "width: 1%"></label>

    <select *ngIf="!heddin_pdl1"  id="pdl1" name="pdl1" [(ngModel)]="pdl1"  style="width: {{pdl1size}}%;background-color:  rgb(187, 203, 238);"    required>
            <option value="">Select* </option>
            <option value="Positive">Positive </option>
            <option value="Negative">Negative</option>
    </select>
    <label *ngIf="!heddin_pdl1"  style = "width: 1%;"></label>

    <select  *ngIf="!heddin_brca1" id="brca1" name="brca1" [(ngModel)]="brca1" style="width: {{brcasize}}%;background-color:  rgb(187, 203, 238);" required>
      <option value="">Select* </option>
      <option value="Mutant">Mutant</option>
      <option value="Non Mutant">non Mutant</option>
    </select>
    <label  *ngIf="!heddin_brca1" style = "width: 1%;"></label>

    <select  *ngIf="!heddin_brca2" id="brca2" name="brca2" [(ngModel)]="brca2" style="width: {{brcasize}}%;background-color:  rgb(187, 203, 238);" required>
              <option value="">Select* </option>
              <option value="Mutant">Mutant</option>
              <option value="Non Mutant">non Mutant</option>
    </select>
    <label  *ngIf="!heddin_brca2" style = "width: 1%;"></label>

    <select *ngIf="!heddin_msi"  id="msi" name="msi" [(ngModel)]="msi" style="width: {{msisize}}%;background-color:  rgb(187, 203, 238);"    required>
          <option value="">Select* </option>
          <option value={{msivalue1}}>{{msivalue1}} </option>
          <option value={{msivalue2}}>{{msivalue2}}</option>
    </select>
    <label *ngIf="!heddin_msi"  style = "width: 1%;"></label>

    <select *ngIf="!heddin_egfr"  id="egfr" name="egfr" [(ngModel)]="egfr" style="width: {{egfrsize}}%;background-color:  rgb(187, 203, 238);"   required>
        <option value="">Select* </option>
        <option value="Mutant">Mutant</option>
        <option value="Wild">Wild</option>
    </select>
    <label *ngIf="!heddin_egfr"  style = "width: 1%;"></label>

    <select *ngIf="!heddin_alk"  id="alk" name="alk" [(ngModel)]="alk" style="width: {{alksiz}}%;background-color:  rgb(187, 203, 238);"   required>
        <option value="">Select* </option>
        <option value="Mutant">Mutant</option>
        <option value="Wild">Wild</option>
    </select>
    <label *ngIf="!heddin_alk"  style = "width: 1%;"></label>


  <select *ngIf="!heddin_kras"  id="kras" name="kras" [(ngModel)]="kras" style="width: {{krassize}}%;background-color:  rgb(187, 203, 238);"   required>
    <option value="">Select* </option>
    <option value={{krasvalue1}}>{{krasvalue1}}</option>
    <option value={{krasvalue2}}>{{krasvalue2}}</option>
</select>
<label *ngIf="!heddin_kras"  style = "width: 1%;"></label>

<select *ngIf="!heddin_braf"  id="braf" name="braf" [(ngModel)]="braf" style="width: {{brafsize}}%;background-color:  rgb(187, 203, 238);"   required>
  <option value="">Select* </option>
  <option value={{brafvalue1}}>{{brafvalue1}}</option>
  <option value={{brafvalue2}}>{{brafvalue2}}</option>
</select>
<label *ngIf="!heddin_braf"  style = "width: 1%;"></label>

<select *ngIf="!heddin_hrd"  id="hrd" name="hrd" [(ngModel)]="hrd" style="width: {{hrdsize}}%;background-color:  rgb(187, 203, 238);"   required>
  <option value="">Select* </option>
  <option value="Positive">Positive</option>
<option value="Negative">Negative</option>
</select>
<label  *ngIf="!heddin_hrd" style = "width: 1%;"></label>



      <select  *ngIf="!heddin_gscore" id="gscore" name="gscore" [(ngModel)]="gscore" style="width: {{gscoresize}}%;background-color:  rgb(187, 203, 238);"   required>
              <option value="">Select* </option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="10">10</option>
      </select>
      <label  *ngIf="!heddin_gscore" style = "width: 1%;"></label>

      <select  *ngIf="!heddin_nfeature" id="nfeatrure" name="nfeatrure" [(ngModel)]="nfeature"  style="width: {{Neuroendocrinesize}}%;background-color:  rgb(187, 203, 238);"    required>
            <option value="">Select* </option>
            <option value="Present">Present </option>
            <option value="Aabsent">Aabsent</option>
     </select>
     <label  *ngIf="!heddin_nfeature" style = "width: 1%"></label>


      <select *ngIf="!heddin_hpv" id="hpv" name="hpv" [(ngModel)]="hpv" style="width: 8%;background-color:  rgb(187, 203, 238);"   required>
        <option value="">Select* </option>
        <option value="Positive">Positive </option>
        <option value="Negative">Negative</option>
      </select>
  </div>
  </div>
</section>
<!-- ---------- End For the 12 Cancer Types  Line 1 --------------- -->
<!-- *********** Start For General Cancer Types ************** -->

  <div class="styled-input">

              <label *ngIf="!heddin_digstage" class="Header-Lab" style = "color: #fff;width: {{digstagesize0}}%;">{{digstagehed}}</label>
              <label *ngIf="!heddin_digstage" style = "width: 0.5%;"></label>

              <label  *ngIf="!heddin_gradehed" class="Header-Lab" style = "color: #fff;width: {{gradesize0}}%;">{{gradehed}}</label>
              <label  *ngIf="!heddin_gradehed" style = "width: 0.5%;"></label>

              <label *ngIf="!heddin_digt" class="Header-Lab" style = "color: #fff;width: {{digtsize0}}%;">{{digthed}}</label>
              <label *ngIf="!heddin_digt" style = "width: 0.5%;"></label>

              <label *ngIf="!heddin_dign" class="Header-Lab" style = "color: #fff;width: {{dignsize0}}%;">{{dignhed}}</label>
              <label *ngIf="!heddin_dign" style = "width: 0.5%;"></label>

              <label *ngIf="!heddin_digm" class="Header-Lab" style = "color: #fff;width: {{digmsize0}}%;">{{digmhed}}</label>
 
    <div class="appointment-form-field">
        <select  *ngIf="!heddin_digstage" id="PatientStatus" name="PatientStatus" [(ngModel)]="digstage" style="width: {{digstagesize}}%;background-color:  rgb(187, 203, 238);" required>
                <option value="0">Select* </option>
                <option value="Stage I">Stage I </option>
                <option value="Stage II">Stage II</option>
                <option value="Stage III">Stage III</option>
                <option value="Stage IV">Stage IV</option>
                <option value="NK">NK</option>
            </select>
            <label *ngIf="!heddin_digstage" style = "width: 1%;"></label>

            <select *ngIf="!heddin_grade" id="visgrade" name="visgrade" [(ngModel)]="grade" style="width: {{gradesize}}%;background-color:  rgb(187, 203, 238);"   required>
              <option value="0">Select* </option>
              <option value={{valuegrad1}}>{{valuegrad1}} </option>
              <option value={{valuegrad2}}>{{valuegrad2}}</option>
              <option value={{valuegrad3}}>{{valuegrad3}}</option>
              <option value={{valuegrad4}}>{{valuegrad4}}</option>
              <option value={{valuegrad5}}>{{valuegrad5}}</option>
          </select>
          <label style = "width: 1%;"></label>
          <select *ngIf="!heddin_digt" id="vist" name="vist" [(ngModel)]="digt"  style="width: {{digtsize}}%;background-color:  rgb(187, 203, 238);"    required>
            <option value="">Select* </option>
            <option value={{digtvalue1}}>{{digtvalue1}} </option>
            <option value={{digtvalue2}}>{{digtvalue2}}</option>
            <option value={{digtvalue3}}>{{digtvalue3}}</option>
            <option value={{digtvalue4}}>{{digtvalue4}}</option>
            <option value={{digtvalue5}}>{{digtvalue5}}</option>
            <option value={{digtvalue6}}>{{digtvalue6}}</option>

        </select>
        <label style = "width: 1%;"></label>
        <select *ngIf="!heddin_dign" id="visn" name="visn" [(ngModel)]="dign" style="width: {{dignsize}}%;background-color:  rgb(187, 203, 238);"    required>
          <option value="">Select* </option>
          <option value={{dignvalue1}}>{{dignvalue1}} </option>
          <option value={{dignvalue2}}>{{dignvalue2}} </option>
          <option value={{dignvalue3}}>{{dignvalue3}} </option>
          <option value={{dignvalue4}}>{{dignvalue4}} </option>
          <option value={{dignvalue5}}>{{dignvalue5}} </option>

      </select>
      <label style = "width: 1%;"></label>
      <select *ngIf="!heddin_digm" id="vism" name="vism" [(ngModel)]="digm" style="width: {{digmsize}}%;background-color:  rgb(187, 203, 238);"   required>
        <option value="">Select* </option>
        <option value={{digmvalue1}}>{{digmvalue1}} </option>
        <option value={{digmvalue2}}>{{digmvalue2}}</option>
        <option value={{digmvalue3}}>{{digmvalue3}}</option>

    </select>
  </div>
 </div>
  <BR>

<!-- *********** End For General Cancer Types ************** -->
  <br>
  <br>
  <div class="appointment-form-field">
    <!-- <span class="fa fa-search-plus" aria-hidden="true" style="height: 200%;cursor: zoom-in;"  title="Zoom In"></span>
    <textarea rows = "5" cols = "60" name = "Diagnosis" [(ngModel)]= "dignotes" class="appointment-form-field" style="height: 200%;" (keyup)="limitLineLength()" > Enter details here... </textarea> -->
    <angular-editor  [config]="editorConfigNoToolbar"  [placeholder]="'Enter text here...'" [(ngModel)]="dignotes" (ngModelChange)="updatePlainText()"></angular-editor>

  </div>


</div>
<br>
<BR>
  <BR>
    <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px; font-weight: bold;background-color: rgb(0, 86, 0);color: white; border-style: none;height: 60%;" name="submit" (click)="Save_Data()" >{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 60px;font-weight: bold;background-color: rgb(1, 19, 58);color: white;border-style: none;height: 60%;" name="Back" (click)="Exit_Data()">{{ 'Home' | translate }}</button>
    <label style="width: 25%;"></label>
  </form>


